export default "__VITE_ASSET__DaZtXUxT__"